<script>

	import {onMount} from "svelte";
	import {makeLmsRequest} from "../service/LmsClient";
	import ManageCircles from "./ManageCircles.svelte";
	import Loader from "../../Common/Loader.svelte";
	import Dropdown from "../../Common/Dropdown.svelte";
	import CircleSummary from "./CircleSummary.svelte";
	import TrackedContent from "./TrackedContent.svelte";
	import PaidContent from "./PaidContent.svelte";
	import {M} from "../../external";

	export let memberId = 0, contactId = 0, groupIds = [];

	let circles = [];
	let activeCircle = null;
	let loading = true;
	let allCirclesSelected = false;
	let memberDetails = null;
	let trackedContentTab = 'enrolled';

  const listAvailableCircles = (memberDetails) => {
    const allCircles = memberDetails.circles.map(detail => detail.circle);
    const filterCircles = (accesses, circleId) => {
      const access = accesses.find(access => access.itemId === circleId);
      return !['BANNED', 'ACCESS_REQUESTED'].includes(access.status);
    }

    return allCircles.filter(circle => filterCircles(memberDetails.access, circle.id));
  }

	let load = async () => {
		loading = true;
		let response = await makeLmsRequest("/circle/member/" + memberId + "/details", "GET")
		memberDetails = await response.json();
    const circlesToUse = listAvailableCircles(memberDetails);

		circles = [
			{
				id: '',
				name: M.ALL_CIRCLES
			},
			...circlesToUse
		];

		activeCircle = circles[0];
		allCirclesSelected = true;
		loading = false;
	}

	let onCircleChanged = (circle) => {
		activeCircle = circle;
	}

	onMount(load);

</script>

{#if loading}
	<Loader compact={true}/>
{:else}
	<div class="col20 f-left flex align-center">
		<h3>{M.ANALYTICS}</h3>
		{#if circles.length > 1}
			<Dropdown items={circles} activeItem={activeCircle} on:change={(event) => onCircleChanged(event.detail.selected)} class="ml-15"
								innerClass="blue"/>
		{/if}
	</div>

	{#key activeCircle}
		<CircleSummary circle={activeCircle} memberDetails={memberDetails} memberId={memberId}/>
	{/key}


	{#if allCirclesSelected === true}
		<ManageCircles
			accesses={memberDetails.access}
			circles={memberDetails.circles}
			memberId={memberId}
      contactId={contactId}
			on:enrolled={load}
			on:unenrolled={load}
			on:banned={load}
			on:unbanned={load}
			on:approved={load}
			on:rejected={load}
			on:role_changed={load}
		/>
	{/if}

	{#if circles.length > 1}
		<div class="col20 f-left mt-25">
			<div class="upper-navigation upper-navigation-full inner-upper-nav mb-25">
				<ul>
					<li on:click={() => trackedContentTab = 'enrolled'}><a class:active={trackedContentTab === 'enrolled'}>{M.TRACKED_CONTENT}</a></li>
					<li on:click={() => trackedContentTab = 'paid'}><a class:active={trackedContentTab === 'paid'}>{M.PAID_CONTENT}</a></li>
				</ul>
			</div>

			{#if trackedContentTab === 'enrolled'}
				{#key activeCircle}
					<TrackedContent circle={activeCircle} memberDetails={memberDetails}/>
				{/key}
			{:else if trackedContentTab === 'paid'}
				{#key activeCircle}
					<PaidContent circle={activeCircle} memberDetails={memberDetails} contactId={contactId} memberId={memberId}/>
				{/key}
			{/if}
		</div>
	{/if}
{/if}



